import { render, staticRenderFns } from "./UserAvatarComponent.vue?vue&type=template&id=7f59eb44&scoped=true&"
import script from "./UserAvatarComponent.vue?vue&type=script&lang=js&"
export * from "./UserAvatarComponent.vue?vue&type=script&lang=js&"
import style0 from "./UserAvatarComponent.vue?vue&type=style&index=0&id=7f59eb44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f59eb44",
  null
  
)

export default component.exports